import { render, staticRenderFns } from "./cookies-tab.vue?vue&type=template&id=b174614a"
import script from "./cookies-tab.vue?vue&type=script&lang=js"
export * from "./cookies-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports